import { render, staticRenderFns } from "./SCreditCard.vue?vue&type=template&id=54706dc9&scoped=true&"
import script from "./SCreditCard.vue?vue&type=script&lang=js&"
export * from "./SCreditCard.vue?vue&type=script&lang=js&"
import style0 from "./SCreditCard.vue?vue&type=style&index=0&id=54706dc9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54706dc9",
  null
  
)

export default component.exports